import { useEffect, useRef } from "react";
import "./LogoStrip.css";

const BrandLogoStrip = () => {
  const logos = [
    "/images/brands/Amazon_logo.webp",
    "/images/brands/nestle_logo.png",
    "/images/brands/honda_logo.jpg",
    "/images/brands/tvs_logo.png",
    "/images/brands/bluedart_logo.png",
    "/images/brands/renault_logo.svg",
    "/images/brands/bosch_logo.png",
    "/images/brands/DHL_Logo.png",
    "/images/brands/Adani_logo.png",
    "/images/brands/instant_logo.png",
    "/images/brands/kapoor_diesels_logo.png",
    "/images/brands/hello_tractor_logo.png",
    "/images/brands/portman_logistics_logo.png",
    "/images/brands/mdmovers_logo.png",
    "/images/brands/blr_logistics_logo.png",
    "/images/brands/supreme_logo.png",
    "/images/brands/wo_logo.jpg",
    "/images/brands/TRANS_LOGO.jpg",
  ];

  //   const stripRef = useRef(null);

  //   useEffect(() => {
  //     const strip = stripRef.current;
  //     let scrollAmount = 0;

  //     const scrollLogos = () => {
  //       if (strip) {
  //         scrollAmount += 1;
  //         if (scrollAmount >= strip.scrollWidth / 2) {
  //           scrollAmount = 0;
  //           strip.scrollLeft = 0;
  //         } else {
  //           strip.scrollLeft += 1;
  //         }
  //       }
  //     };

  //     const interval = setInterval(scrollLogos, 20);
  //     return () => clearInterval(interval);
  //   }, []);

  return (
    <div className="container-fluid logo-strip-container">
      <div className="d-flex logo-wrapper">
        {/* Original List */}
        <div className="logo-strip">
          {logos?.map((logo, index) => (
            <img key={index} src={logo} alt={`Brand ${index + 1}`} />
          ))}
        </div>
        {/* Duplicate for Infinite Scroll Effect */}
        <div className="logo-strip">
          {logos?.map((logo, index) => (
            <img
              key={index + logos.length}
              src={logo}
              alt={`Brand ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandLogoStrip;
